export default function ({ next, store }) {
  // If the user is authenticated redirect to home page
  if (store.state.authCustom.auth) {
    return next({
      path: "/",
    });
  }
  return next();
}
